export default __webpack_public_path__ + "16dc2c6.svg";